"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _web = require("@react-spring/web");
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _icons = require("../icons");
var _layout = require("../layout");
var _liveAnnouncer = require("../live-announcer");
var _utils = require("../utils");
var _MessageBannerDismissButton = _interopRequireDefault(require("./MessageBannerDismissButton"));
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _interfaces = require("./interfaces");
var _core = require("@emotion/core");
var _excluded = ["aria-live", "autoDismissAfter", "children", "contentWrapperProps", "dismissButtonAltText", "dismissButtonAriaDescribedby", "icon", "iconAltText", "isDismissible", "onDismissed", "titleText", "hasRoundedCorners", "type"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var MessageBannerWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLive = _ref['aria-live'],
    autoDismissAfter = _ref.autoDismissAfter,
    children = _ref.children,
    contentWrapperProps = _ref.contentWrapperProps,
    _ref$dismissButtonAlt = _ref.dismissButtonAltText,
    dismissButtonAltText = _ref$dismissButtonAlt === void 0 ? _constants.MessageBannerDefaultProps.dismissButtonAltText : _ref$dismissButtonAlt,
    dismissButtonAriaDescribedby = _ref.dismissButtonAriaDescribedby,
    providedIcon = _ref.icon,
    iconAltText = _ref.iconAltText,
    isDismissible = _ref.isDismissible,
    onDismissed = _ref.onDismissed,
    titleText = _ref.titleText,
    _ref$hasRoundedCorner = _ref.hasRoundedCorners,
    hasRoundedCorners = _ref$hasRoundedCorner === void 0 ? _constants.MessageBannerDefaultProps.hasRoundedCorners : _ref$hasRoundedCorner,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? _constants.MessageBannerDefaultProps.type : _ref$type,
    forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var rowRef = (0, _react.useRef)(null);
  var Icon = _constants.MessageBannerTypeIcons[type];
  var colorBase = _constants.MessageBannerTypeColors[type];
  var transitions = (0, _web.useTransition)(isVisible, {
    from: {
      opacity: 1
    },
    enter: {
      opacity: 1
    },
    leave: [{
      opacity: 0
    }, {
      height: 0
    }],
    onDestroyed: function onDestroyed() {
      return !!onDismissed && onDismissed();
    }
  });
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isMouseFocus = _useState4[0],
    setIsMouseFocus = _useState4[1];
  var handleMouseDown = function handleMouseDown(e) {
    var wrapperRef = ref || rowRef;
    if (wrapperRef.current && wrapperRef.current.contains(e.target)) {
      // Used to prevent visually focusing the banner on mouse click.
      setIsMouseFocus(true);
    }
  };
  var handleOnBlur = function handleOnBlur(e) {
    var wrapperRef = ref || rowRef; // Reset mouse focus unless internal elements had focus before.

    if (wrapperRef.current && !wrapperRef.current.contains(e.relatedTarget)) {
      setIsMouseFocus(false);
    }
  };
  (0, _react.useEffect)(function () {
    var timeout;
    if (autoDismissAfter && isVisible) {
      timeout = window.setTimeout(function () {
        setIsVisible(false);
      }, autoDismissAfter);
    }
    return function () {
      timeout && clearTimeout(timeout);
    };
  }, [isVisible, autoDismissAfter]);
  var titleTextId = (0, _react.useMemo)(function () {
    return titleText ? (0, _utils.getUniqueId)('message-banner-title-') : undefined;
  }, [titleText]);
  var dismissButtonAriaDescribedbyValue = dismissButtonAriaDescribedby !== null && dismissButtonAriaDescribedby !== void 0 ? dismissButtonAriaDescribedby : titleTextId;
  return transitions(function (styles, item) {
    return item && (0, _core.jsx)(_web.animated.div, {
      style: styles
    }, (0, _core.jsx)(_helperComponents.MessageBannerRow, (0, _extends2.default)({}, (0, _utils.pickDataProps)(forwardedProps), {
      colorBase: colorBase,
      isMouseFocus: isMouseFocus,
      hasRoundedCorners: hasRoundedCorners,
      onBlur: handleOnBlur,
      onMouseDown: handleMouseDown,
      ref: ref || rowRef,
      tabIndex: -1
    }), (0, _core.jsx)(_liveAnnouncer.LiveRegion, {
      role: _liveAnnouncer.LiveRegionRole.Status // Only announce if visible (when it appears), otherwise it would announce when dismissing
      ,

      "aria-live": ariaLive && isVisible ? ariaLive : 'off'
    }, (0, _core.jsx)(_helperComponents.MessageBannerIconWrapper, {
      colorBase: colorBase
    }, providedIcon || (0, _core.jsx)(Icon, {
      size: _icons.IconSize.ExtraSmall,
      title: iconAltText || _constants.MessageBannerDefaultAltTexts[type]
    })), (0, _core.jsx)(_layout.View, contentWrapperProps, titleText && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_helperComponents.MessageBannerText, {
      dataTestComponent: "MessageBannerTitle",
      id: titleTextId
    }, (0, _core.jsx)("strong", null, titleText)), (0, _core.jsx)(_layout.Spacer, {
      width: 8,
      display: "inline-block"
    })), (0, _core.jsx)(_helperComponents.MessageBannerText, {
      dataTestComponent: "MessageBannerContent"
    }, children))), isDismissible && (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Spacer, {
      flex: 1
    }), (0, _core.jsx)(_helperComponents.MessageBannerIconWrapper, null, (0, _core.jsx)(_MessageBannerDismissButton.default, {
      "aria-describedby": dismissButtonAriaDescribedbyValue,
      colorBase: colorBase,
      iconAltText: dismissButtonAltText,
      setIsVisible: setIsVisible
    })))));
  });
});
var MessageBannerWithDocs = (0, _stencilReactDesc.describe)(MessageBannerWithoutDocs).description('Banner used for alert style messages.');
MessageBannerWithDocs.defaultProps = _objectSpread({}, _constants.MessageBannerDefaultProps);
MessageBannerWithDocs.propTypes = {
  'aria-live': _stencilReactDesc.PropTypes.oneOf(['polite', 'assertive', 'off']).description('Sets "aria-live" on the message banner.'),
  autoDismissAfter: _stencilReactDesc.PropTypes.number.description('Amount of time after which the component will automatically dismiss, in milliseconds.'),
  children: _stencilReactDesc.PropTypes.node.isRequired.description('Main content to display in the banner.'),
  dismissButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the "dismiss" button.'),
  dismissButtonAriaDescribedby: _stencilReactDesc.PropTypes.string.description('Sets "aria-describedby" on the "dismiss" button. As default this will be set to the titleText ID if titleText is defined.'),
  icon: _stencilReactDesc.PropTypes.node.description('Icon to display on the leading side of the message banner.'),
  iconAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the icon displayed on the leading side of the banner. The text should be tailored to the type of banner.'),
  isDismissible: _stencilReactDesc.PropTypes.bool.description('Adds a "dismiss" button to the banner which hides the banner.'),
  onDismissed: _stencilReactDesc.PropTypes.func.description('Function called once the message banner has finished dismissing after the dismiss button has been clicked.').format('() => void'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title text to display in the banner before the main content.'),
  type: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.MessageBannerType)).description('The type of message being displayed in the banner. Affects the visual style of the banner.'),
  hasRoundedCorners: _stencilReactDesc.PropTypes.bool.description('Whether the component should have rounded corners. You can turn it off when the component is outside of the content grid and full width.')
};
var MessageBanner = (0, _utils.withTestAttributes)({
  component: 'StencilReactMessageBanner'
})(MessageBannerWithDocs);
MessageBanner.displayName = 'MessageBanner';
var _default = MessageBanner;
exports.default = _default;